var map = {
	"./22_mummy.mp3": "f663",
	"./23_daddy.mp3": "64fc",
	"./24_sister.mp3": "8d1f",
	"./25_brother.mp3": "10a9",
	"./M_Brilliant.mp3": "53ff",
	"./M_Excellent.mp3": "8038",
	"./M_Fantastic.mp3": "3972",
	"./M_Great.mp3": "70c3",
	"./M_Perfect.mp3": "0b87",
	"./M_Think again.mp3": "3066",
	"./M_Try again.mp3": "aad1",
	"./M_Very good.mp3": "65f4",
	"./M_Well done.mp3": "202b",
	"./M_Work harder.mp3": "2236",
	"./click.mp3": "267c",
	"./empty_true.mp3": "03bc",
	"./false.mp3": "b781",
	"./true.mp3": "b411"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7e8";